<template>
  <div
      class="activity"
      :class="{
      'activity-top': showDescription,
      'activity-simple': !showDescription
    }"
  >
    <b-row>
      <b-col class="activity__title">
        {{ conference.name }}
      </b-col>
      <b-col class="activity__date">
        {{ conference.date | formatDateAndTime }}
      </b-col>
    </b-row>
    <b-row v-if="conference.media && conference.media.url">
      <b-col style="padding-top: 10px; padding-bottom: 10px;">
        <img :src="conference.media.url" class="img-fluid" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div style="text-align: left">
          <b>Conférenciers</b> :
          <template v-for="speaker in conference.speakers">{{speaker.name}},</template>
        </div>
        <vue-markdown
            class="activity__description"
            style="padding-top: 0;"
            :source="conference.description"
            :strict="false"
        />
      </b-col>
      <b-col cols="5">
        <table class="table table-bordered table--price">
          <tr>
            <th>Prix membre</th>
            <td>{{conference.price ? conference.price.priceMember : null | formatMoney}}</td>
          </tr>
          <tr v-if="conference.membersOnly === false">
            <th>Prix régulier</th>
            <td>{{conference.price ? conference.price.priceRegular : null | formatMoney}}</td>
          </tr>
          <tr>
            <th>Prix mineur membre</th>
            <td>{{conference.priceMinor ? conference.priceMinor.priceMember : null | formatMoney}}</td>
          </tr>
          <tr v-if="conference.membersOnly === false">
            <th>Prix mineur régulier</th>
            <td>{{conference.priceMinor ? conference.priceMinor.priceRegular : null | formatMoney}}</td>
          </tr>
          <tr>
            <th>Surplus* membre</th>
            <td>
              {{conference.surplusNonResident ? conference.surplusNonResident.priceMember : null | formatMoney}}
            </td>
          </tr>
          <tr v-if="conference.membersOnly === false">
            <th>Surplus* régulier</th>
            <td>
              {{conference.surplusNonResident ? conference.surplusNonResident.priceRegular : null | formatMoney}}
            </td>
          </tr>
          <tr>
            <th>Surplus* si mineur</th>
            <td>
              {{conference.surplusNonResidentMinor ? conference.surplusNonResidentMinor.priceMember : null | formatMoney}}
            </td>
          </tr>
          <tr v-if="conference.membersOnly === false">
            <th>Surplus* régulier</th>
            <td>
              {{conference.surplusNonResidentMinor ? conference.surplusNonResidentMinor.priceRegular : null | formatMoney}}
            </td>
          </tr>
          <tr>
            <th>Limite d'inscriptions</th>
            <td>{{conference.registrationMaximum}}</td>
          </tr>
        </table>
        <p style="text-align: left; margin-top: 5px; margin-bottom: 10px; padding-top: 0; font-size: 10px;">
          * Surplus uniquement si vous n'habitez pas la ville de Québec.
        </p>
      </b-col>
    </b-row>
    <!-- <b-row>
      <b-col>

        <template v-if="isConnected && conference.acceptRegistrations === true">
          <b-button

              variant="primary"
              @click="showRegisterModal"
              style="width: 100%"
          >
            Inscription à la conférence
          </b-button>
        </template>
        <template v-else-if="conference.acceptRegistrations === false">
          <b-button  variant="outline-secondary" style="width: 100%">
            Les inscriptions ne sont pas encore activés
          </b-button>
        </template>
        <template v-else>
          <b-button  variant="outline-secondary" style="width: 100%">
            Vous devez être connecté pour participer à cette conférence
          </b-button>
        </template>
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
  import ConferenceRegistrationModal from './Conference_Inscription';
  import { mapGetters } from 'vuex';

  export default {
    name: 'conference-entry',
    props: {
      conference: {
        type: Object
      },
      showDescription: {
        type: Boolean,
        default: () => true
      }
    },
    computed: {
      ...mapGetters({
        isConnected: 'account/isConnected'
      })
    },
    methods: {
      async showRegisterModal() {
        // Ask the user to confirm and select the member to be registered.
        await this.$store.dispatch('members/fetchMembers');
        // Show modal
        this.$modal.show(
          ConferenceRegistrationModal,
          {
            conferenceId: this.conference.id
          },
          {
            height: 'auto',
            minHeight: 300,
            name: 'conference-registration-modal',
            root: this.$root
          }
        );
      }
    }
  };
</script>

<style lang="scss">
  // Check ../Activity/ActivityEntry.vue

  .table--price {
    tr {
      th, td {
        text-align: left;
        font-size: 12px;
      }
      th {
        font-weight: 600 !important;
      }
    }
  }
</style>
